import { render } from "./PreLoginLegalDisclaimer.vue?vue&type=template&id=1435493a&scoped=true"
import script from "./PreLoginLegalDisclaimer.vue?vue&type=script&lang=js"
export * from "./PreLoginLegalDisclaimer.vue?vue&type=script&lang=js"

import "./PreLoginLegalDisclaimer.vue?vue&type=style&index=0&id=1435493a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1435493a"]])

export default __exports__